/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Failure_FailedInputs */

const en_sync_failure_failed = /** @type {(inputs: Sync_Failure_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Central could not take the last state sent for a technical problem. Send again.`)
};

/**
* | output |
* | --- |
* | "Business Central could not take the last state sent for a technical problem. Send again." |
*
* @param {Sync_Failure_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const sync_failure_failed = /** @type {((inputs?: Sync_Failure_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Failure_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_sync_failure_failed(inputs)
});